import React, { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import InputField from '../../../Components/InputField';
import Button from '../../../Components/Button';
import SelectBox from '../../../Components/Select';

import { GlobalContext } from '../../../GlobalContext';

const UserManagement = () => {

    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);

    useEffect(() => {
        setCurrentTab('User management');
    });

    //--------------mouse drage(resize width)--------------
    const containerRef = useRef(null);
    const [columnWidths, setColumnWidths] = useState([]);
    const [isResizing, setIsResizing] = useState(false);
    const [startX, setStartX] = useState(0);
    const [currentColumnIndex, setCurrentColumnIndex] = useState(null);
    const numberOfColumns = 4; // Adjust this based on your actual number of columns

    useEffect(() => {
        const containerWidth = containerRef.current ? containerRef.current.clientWidth : 0;
        const initialWidth = containerWidth / numberOfColumns; // Divide the container width by the number of columns
        setColumnWidths(Array(numberOfColumns).fill(initialWidth)); // Set initial widths
    }, []);

    const handleMouseDown = (e, index) => {
        e.preventDefault(); // Prevent default behavior
        setIsResizing(true);
        setStartX(e.clientX);
        setCurrentColumnIndex(index);
    };

    const handleMouseMove = (e) => {
        if (isResizing && currentColumnIndex !== null) {
            const newWidths = [...columnWidths];
            const newWidth = newWidths[currentColumnIndex] + (e.clientX - startX);
            newWidths[currentColumnIndex] = Math.max(newWidth, 50); // Prevent column from being too small

            // Calculate total width of columns
            const totalWidth = newWidths.reduce((acc, width) => acc + width, 0);
            const containerWidth = containerRef.current.clientWidth; // Get the container width

            // If total width exceeds container width, adjust the widths proportionally
            if (totalWidth > containerWidth) {
                const excessWidth = totalWidth - containerWidth;
                const adjustment = excessWidth / (newWidths.length - 1); // Adjust all but the resized column

                newWidths.forEach((_, idx) => {
                    if (idx !== currentColumnIndex) {
                        newWidths[idx] = Math.max(newWidths[idx] - adjustment, 50); // Prevent columns from being too small
                    }
                });
            }

            setColumnWidths(newWidths);
            setStartX(e.clientX);
        }
    };

    const handleMouseUp = () => {
        setIsResizing(false);
        setCurrentColumnIndex(null);
    };

    useEffect(() => {
        if (isResizing) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing, currentColumnIndex]);

    const headArray = ['User name','Group ban','User prioity','Operation'];

    const selectPageArray = ['20/page','40/page','60/page','80/page'];
    
    const gotoGroupListClick = () => {
        navigate(`/grouplist`); // Use navigate for routing
    };

    return (
        <div className='h-full'>
            <div className='w-full flex justify-between items-center bg-[#f0f0f0] my-2.5 p-2.5' style={{ fontFamily: 'Liberation Serif' }}>
                <div>
                    <Button onClick={gotoGroupListClick} children={'Back'} />
                </div>
                <div className='flex items-center'>
                    <span className='mr-[5px] text-[14px] text-[#5a5655]'>Key words:</span>
                    <InputField placeholder={'User Name'} />
                    <div>&nbsp;</div>
                    <Button children={'Search'} />
                </div>
            </div>
            <div className='w-full h-[calc(100%-180px)] border-r-0 border-b-0 bg-[#f0f0f0]' ref={containerRef}>
                <div className='overflow-auto'>
                    <table className='overflow-auto table-fixed border-collapse border border-[#ebeef5]'>
                        <thead className='text-[#909399] font-medium'>
                            <tr className='bg-[#fafafa]' style={{ fontFamily: 'SimSun' }}>
                                {columnWidths.map((width, index) => (
                                    <th key={index} style={{ width }} className='border-collapse border border-[#ebeef5] select-none bg-white py-3 min-w-0 truncate align-middle relative text-left text-sm font-normal'>
                                        <div onMouseDown={(e) => handleMouseDown(e, index)} className='cursor-col-resize text-center text-black font-bold break-words leading-[27px] pl-2.5 inline-block relative align-middle pr-2.5 w-full truncate whitespace-normal' style={{ fontFamily: 'Liberation Serif' }}>
                                            {headArray[index]}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
            <div className='flex items-center mt-[12px]'>
                <div className='flex whitespace-nowrap text-[#303133] font-bold'>
                    <span className='inline-block text-[13px] min-w-[35.5px] h-[28px] leading-[28px] align-top mr-2.5 font-normal text-[#606266]'>totally 0 item</span>
                    <ul className="flex space-x-2 justify-center">
                        <li className="flex items-center justify-center shrink-0 bg-gray-100 w-[30px] h-[28px] rounded-md">
                            <svg
                                className="w-3 fill-gray-300"
                                viewBox="0 0 55.753 55.753"
                            >
                                <path
                                    d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z"
                                    data-original="#000000"
                                />
                            </svg>
                        </li>
                        <li className="flex items-center justify-center shrink-0 cursor-pointer text-base font-bold text-[#fff] px-[13px] w-[30px] h-[28px] rounded-sm bg-[#3877c6]" style={{fontFamily:'SimSul'}}>
                            1
                        </li>
                        <li className="flex items-center justify-center shrink-0 bg-gray-100 w-[30px] h-[28px] rounded-md">
                            <svg
                                className="w-3 fill-gray-300 rotate-180"
                                viewBox="0 0 55.753 55.753"
                            >
                                <path
                                    d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z"
                                    data-original="#000000"
                                />
                            </svg>
                        </li>
                    </ul>
                    <span className='inline-block text-[13px] min-w-[35.5px] h-[28px] leading-[28px] align-top font-normal text-[#606266] ml-[5px]'>
                        Go to
                        <div className='w-[50px] inline-block ml-[5px]'>
                            <input
                                type="text"
                                placeholder="1"
                                className="h-[28px] px-1 text-[14px] rounded-md bg-white border border-[#dcdfe6] w-full outline-blue-500 text-center"
                            />
                        </div>
                    </span>
                    <Button children={'Confirm'} className={'!h-[28px] !py-1 !w-[60px] !px-0 ml-[5px]'}/>
                    <SelectBox options={selectPageArray} className={'!w-[100px] !h-[28px]'}/>
                </div>
            </div>
        </div>
    );
}
export default UserManagement;